import { render, staticRenderFns } from "./ReservedInvestments.vue?vue&type=template&id=26f6e46b&"
import script from "./ReservedInvestments.vue?vue&type=script&lang=js&"
export * from "./ReservedInvestments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports